"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfillers = void 0;
var fulfillerIdentityUrl = 'https://identity.financialflows.cimpress.io';

var getFulfillers = function getFulfillers(fulfillerIds, onGetAccessToken) {
  var accessToken = onGetAccessToken();
  var headers = new Headers({
    Accept: 'application/json',
    Authorization: "Bearer ".concat(accessToken)
  });
  var idRequest = {
    fulfillerIds: fulfillerIds
  };
  var body = JSON.stringify(idRequest);
  var options = {
    method: 'POST',
    mode: 'cors',
    headers: headers,
    body: body
  };
  return fetch("".concat(fulfillerIdentityUrl, "/v1/fulfillers"), options).then(function (res) {
    if (res.ok) return res.json();
    throw res;
  });
};

exports.getFulfillers = getFulfillers;